module.exports = __webpack_public_path__ + "img/wechat.36cc5bb0.jpg";